export default __webpack_public_path__ + "static/media/background-pairs.849ac5c0.png";